/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpRespSimilarItem_viewer$ref = any;
export type PdpRespSimilarItemsGridSeller_viewer$ref = any;
export type PdpRespSimilarItemsGridSeller_viewer = {
    readonly " $fragmentRefs": PdpRespSimilarItem_viewer$ref;
    readonly " $refType": PdpRespSimilarItemsGridSeller_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpRespSimilarItemsGridSeller_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "PdpRespSimilarItem_viewer",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'b2ac9e95e218aa71d2752773c7d8b309';
export default node;
